const endpoints = {
  listRemunerationsGoal: (): string => `remuneration/goal`,
};

export default endpoints;
